// extracted by mini-css-extract-plugin
export default {"container":"_q-z","heading":"ar-z","text":"br-z","info":"cr-z","link":"dr-z","fullMaxWidth":"er-z"};